const aryApiTypes = {
  graphql: 'graphql',
  rest: 'rest'
};

export default aryApiTypes;
